import { useState } from "react";
import {
    Stack,
    Paper,
    Typography,
    TextField,
    Button
} from "@mui/material";
import OtpCode from "./otpCode";
import { handleSubmit } from "../../Functions";
import errorData from "../../Text/error.json";
import { useAppContext } from "../../context";
import Loader from "../Loader";

type ErrorCode = keyof typeof errorData;


export default function Verification() {

    const [personalId, setPersonalId] = useState("");
    const [mobileNumber, setMobileNumber] = useState("");
    const [showotp, setShowOtp] = useState(false);
    const [retrySend, setRetrySend] = useState(0);
    const { setPopupContent, setErrorMsg } = useAppContext();
    const [loading, setLoading] = useState(false);

    const handleVerification = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        try {
            const res = await handleSubmit({
                personalId,
                mobileNumber
            }, '/api/Account/VerifyClient');
            const raw = res?.error?.data || res?.data;

            let parsed = null;
            let errorMessage = null;
            let errorCode = null;

            if (raw) {
                parsed = JSON.parse(raw);
                if (parsed?.data?.data?.retrySendAfterSecond) {
                    setRetrySend(parsed?.data?.data?.retrySendAfterSecond);
                }
                if (parsed?.data?.error_message) {
                    errorMessage = parsed?.data?.error_message;
                    errorCode = parsed?.data?.error_code;
                }
            }

            if (errorCode) {
                const errorText = errorData[errorCode as ErrorCode] || { title: "ვერიფიკაცია ვერ შესრულდა", message: "გთხოვთ სცადოთ თავიდან", link: "" };
                setErrorMsg({ title: errorText.title, message: errorText.message, link: errorText.link ?? "" });
                setPopupContent("ErrorMessage");

            }

            if (parsed?.success && parsed?.data?.client_active) {
                setShowOtp(true);
            }

        } catch (error) {
            setErrorMsg({ title: "ვერიფიკაცია ვერ შესრულდა", message: "გთხოვთ სცადოთ თავიდან", link: "" });
            setPopupContent("ErrorMessage");
        } finally {
            setLoading(false);
        }



    };
    return (
        <>
            {/* <VerifyError title={errorMsg.title} message={errorMsg.message} /> */}
            {loading && <Loader />}
            {!showotp &&
                <form onSubmit={(e) => { handleVerification(e) }}>
                    <Stack
                        spacing={4}
                        alignItems="center"
                        justifyContent="center"
                        sx={{
                            overflow: "hidden",
                            px: 2,
                            background: "linear-gradient(135deg, #f5f7fa, #e4ecf7)"
                        }}
                    >
                        <Paper
                            elevation={0}
                            sx={{
                                width: "100%",
                                maxWidth: 420,
                                p: { xs: 2.5, sm: 4 },
                                borderRadius: 3,
                                boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                            }}
                        >
                            <Typography
                                variant="h5"
                                fontWeight={700}
                                mb={1}
                                textAlign="center"
                            >
                                ვერიფიკაცია
                            </Typography>

                            <Typography
                                variant="body2"
                                color="text.secondary"
                                textAlign="center"
                                mb={3}
                            >
                                გთხოვთ, გაიაროთ სისტემაში ვერიფიკაცია
                            </Typography>

                            <Stack spacing={2}>
                                <TextField
                                    label="პირადი ნომერი"
                                    value={personalId}
                                    onChange={(e) => setPersonalId(e.target.value)}
                                    fullWidth
                                    autoComplete="off"
                                />

                                <TextField
                                    label="მობილური ნომერი"
                                    value={mobileNumber}
                                    onChange={(e) => setMobileNumber(e.target.value)}
                                    fullWidth
                                    autoComplete="off"
                                />

                                <Button
                                    type="submit"
                                    variant="contained"
                                    fullWidth
                                    sx={{
                                        height: 45,
                                        borderRadius: "10px",
                                        background: "#FF5440"
                                    }}
                                >
                                    ვერიფიკაცია
                                </Button>
                            </Stack>
                        </Paper>
                    </Stack>
                </form>
            }
            {showotp && <OtpCode personalId={personalId} mobileNumber={mobileNumber} retrySend={retrySend} />}
        </>
    );
}